import React, { useEffect, useState } from "react";
import { useTableWeek } from "../../Hooks";
import Loading from "../../../../Common/Loading";
import { Spinner } from "react-bootstrap";
import {
  addTime,
  ConvertDate,
  GenderRender,
  randomBetweenToNumber,
  RenderPrice,
  ToDateJalali,
} from "../../../../Common/Function";
import ShfitTable from "../../../../Common/ShiftTable/index";
import { Color } from "../../../../../Utils/styles";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import CustomModal from "../../../../Common/Modal/CustomModal";
import SelectSans from "../../../../../Panel/Common/Components/SelectSans";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Calendar } from "react-multi-date-picker";
import { Step, StepLabel, Stepper } from "@mui/material";
import { Get, Set } from "../../../../../Request";
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";
import { useCard } from "../../../Card/Hooks";
import AuthModal from "../../../Auth/AuthModal";
function Index({ item, timeTable, timetableRef, isApp }) {
  const dispatch = useDispatch();
  const { week, getWeek } = useTableWeek();
  const [showModalLogin, setShowModalLogin] = useState(false);
  useEffect(() => {
    getWeek({
      item_id: item.id,
    });
  }, []);

  const { user } = useSelector(state => state);
  const obj = {
    id: item.id,
    image: item.images && item.images[0],
    name: item.name,
    categoryName: item.category.name,
  };
  const checkValidate = async () => {
    return await Set({
      url: "/contractreserve/checkdate",
      data: { ...form, item_id: item.id },
      neddata: true,
    }).then(response => {
      return response;
    });
  };
  const checkValidateSans = async () => {
    return await Get({
      url: "/order/check_contractual_reserve",
      data: { ...form, item_id: item.id },
      neddata: true,
    }).then(response => {
      return response;
    });
  };

  const navigate = useNavigate();
  const condition = () => {
    switch (timeTable.showmodel) {
      case "table":
        return <Table item={obj} setShowModalLogin={setShowModalLogin} isApp={isApp} />;
      case "list":
        return (
          <ShfitTable
            stracture={{
              item: obj,
              data: timeTable,
            }}
            isApp={isApp}
          />
        );

      default:
        return <h2 className="text-center my-5">این مجموعه غیر فعال است</h2>;
    }
  };
  const [modal, setModal] = useState({ visible: false, step: 1 });
  const [form, setForm] = useState({ times: [] });
  const renderStateTime = time => {
    if (time.status == "ok") {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <AiFillCheckCircle color={Color.greenLight} />
          <h6
            style={{
              fontSize: "12px",
              fontSize: "11px",
              fontWeight: "400",
              marginRight: "5px",
            }}
          >
            آماده رزرو
          </h6>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <AiFillCloseCircle color={Color.primary} />
          <h6
            style={{
              fontSize: "12px",
              fontSize: "11px",
              fontWeight: "400",
              marginRight: "5px",
            }}
          >
            ظرفیت پر
          </h6>
        </div>
      );
    }
  };
  const renderContract = (isApp) => {
    switch (modal.step) {
      case 1:
        return (
          <div className="d-flex ">
            <h2>
              <h6 htmlFor="" className="mt-4  ">
                تاریخ شروع و پایان قرارداد
              </h6>
              <p
                className="mb-4 mt-2"
                style={{ fontWeight: "400", fontSize: "14px" }}
              >{`بازه قرارداد : ${ToDateJalali(
                timeTable.date_start
              )} تا ${ToDateJalali(timeTable.date_end)}`}</p>
              <Calendar
                range={true}
                onChange={data => {
                  if (data.length > 1) {
                    setForm({
                      ...form,
                      date_start: ConvertDate(
                        `${data[0].year}/${data[0].month.number}/${data[0].day}`
                      ),
                      date_end: ConvertDate(
                        `${data[1].year}/${data[1].month.number}/${data[1].day}`
                      ),
                    });
                  }
                }}
                calendar={persian}
                locale={persian_fa}
              />
            </h2>
          </div>
        );
      case 2:
        return (
          <div className="my-4">
            <SelectSans
              item_id={item.id}
              form={form}
              setform={setForm}
              reserve={true}
              isApp={isApp}
              contractPage={true}
            />
          </div>
        );
      case 3:
        return (
          <>
            <div className="my-4" style={{ display: "flex", flexWrap: "wrap" }}>
              {form.times.map(time => {
                return (
                  <div
                    style={{
                      border: "1px solid #eee",
                      borderRadius: "5px",
                      padding: "10px 15px",
                      margin: "0 8px 8px 8px",
                    }}
                  >
                    <h6
                      style={{
                        fontWeight: "400",
                        textAlign: "center",
                        fontSize: "14px",
                      }}
                    >{`${time.start} تا ${time.end}`}</h6>
                    <h6
                      style={{
                        fontWeight: "400",
                        textAlign: "center",
                        fontSize: "12px",
                        marginTop: "5px",
                      }}
                    >
                      {`${ToDateJalali(time.date)}`}
                    </h6>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      {renderStateTime(time)}
                    </div>
                  </div>
                );
              })}
            </div>
            <p>مبلغ کل : {RenderPrice({ price: form.total_price })}</p>
          </>
        );
      default:
        break;
    }
  };
  return (
    <div className={`${window.screen.width > 760 && "p-3"}`} ref={timetableRef}>
      <div
        className="row"
        style={{ borderBottom: "1px solid #eee", paddingBottom: "10px" }}
      >
        <div
          className="col "
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap"
          }}
        >
          <div className={window.screen.width < 501 && "w-100"}>
            <h5 style={{ color: "#E42A3F" }} className="reserve-item-name">
              <img
                src={window.origin + `/WebSide/assets/images/${99}.png`}
                alt="همه ملاقات"
                style={{
                  width: "40px",
                  height: "40px",
                  marginLeft: "10px",
                }}
              />
              {`رزرو ${item.name} `}
            </h5>
          </div>
          {timeTable.showmodel == "table" ? (
            <div className={window.screen.width < 501 && "mt-2"}>
              <button
                onClick={() => {
                  if (user && user.mobile) {
                    setModal({ visible: true, step: 1 });
                  } else {
                    toast.error("لطفا ابتدا ثبت نام کنید");
                    setTimeout(() => {
                      setShowModalLogin(true)
                    }, 1000);
                  }
                }}
                className="btn btn-primary btn-contract"
              >
                رزرو قراردادی
              </button>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      {condition()}
      <CustomModal
        show={modal.visible}
        header={`رزرو قراردادی ${item.name}`}
        handleClose={() => {
          setModal({ visible: false });
        }}
      >
        <Stepper activeStep={modal.step - 1} orientation={isApp && "vertical"}>
          {[
            {
              name: "مدت قرارداد",
              id: 2,
            },
            {
              name: "انتخاب سانس های قرارداد",
              id: 1,
            },
            {
              name: "تایید سانس ها",
              id: 0,
            },
          ].map((step, index) => {
            return (
              <Step key={step.id}>
                <StepLabel style={{}}><span className="ms-1">{step.name}</span></StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {renderContract(isApp)}
        <div className="row mt-3">
          <div className="col-6"></div>
          <div className={"d-flex justify-content-end " + (isApp ? "col-12" : "col-6")}>
            <button
              className={"btn btn-primary " + (isApp && "w-100")}
              onClick={async () => {
                console.log("-->", form);
                if (modal.step == 1) {
                  await checkValidate().then(res => {
                    if (res) {
                      setModal({ ...modal, step: 2 });
                    } else {
                      toast.error("تاریخ های انتخاب شده مجاز نمی باشد");
                    }
                  });
                } else if (modal.step == 2) {
                  if (form.times.length == 0) {
                    // setModal({ ...modal, step: 3 });
                    toast.error("حداقل یک سانس باید انتخاب شود");
                  } else {
                    await checkValidateSans().then(res => {
                      if (res.acsses == "true") {
                        setModal({ ...modal, step: 3 });
                        setForm({
                          ...form,
                          timesApi: form.times,
                          times: res.times,
                          reqball: false,
                          total_price: res.total_price,
                        });
                      } else {
                        toast.error(
                          "تمام سانس های انتخاب شده در این بازه پر هستند ، برای مشاهده وضعیت سانس ها در زمان مورد نظر به صفحه مجموعه مراجعه کنید"
                        );
                      }
                    });
                  }
                } else {

                  dispatch({
                    local_storage: {
                      key: "basket",
                      value: {
                        expiryTime: addTime(100),
                        reqball: false,
                        step: 1,
                        times: form.times,
                        timeOption: week.option,
                        item: obj,
                        type: "contract",
                        total_price: form.total_price,
                        timesApi: form.timesApi,
                        otherpeopel: [
                          {
                            fullname: user.fullname,
                            mobile: user.mobile,
                            national_code: user.national_code,
                            self: true,
                            id: randomBetweenToNumber(),
                          },
                        ],
                      },
                      date_start: form.date_start,
                      date_end: form.date_end,
                      // date_end
                    },
                    type: "SET",
                    payload: {
                      basket: {
                        expiryTime: addTime(100),
                        step: 1,
                        item: obj,
                        reqball: false,
                        times: form.times,
                        timeOption: week.option,
                        total_price: form.total_price,
                        timesApi: form.timesApi,
                        otherpeopel: [
                          {
                            fullname: user.fullname,
                            mobile: user.mobile,
                            national_code: user.national_code,
                            self: true,
                            id: randomBetweenToNumber(),
                          },
                        ],
                        type: "contract",
                        date_start: form.date_start,
                        date_end: form.date_end,
                      },
                    },
                  });
                  navigate("/card");
                }
              }}
            >
              {modal.step == 3 ? "پرداخت" : "مرحله بعد"}
            </button>
          </div>
        </div>
      </CustomModal>
      <AuthModal show={showModalLogin} setShow={setShowModalLogin} />
    </div>
  );
}

export default Index;
export const Table = ({ item, setShowModalLogin, isApp }) => {
  const {
    loadingWeek,
    week,
    getWeek,
    days,
    convertDay,
    getDate,
    checkCurrentWeek,
    loadingSans,
    changeStatus,
    getYear,
  } = useTableWeek();
  useEffect(() => {
    getWeek({
      item_id: item.id,
    });
  }, []);
  return (
    <div className="table-sans-item">
      <div style={{}}>
        <div className="row justify-content-between py-3" style={{}}>
          <div className="col-6 col-sm-5 col-lg-2 d-flex align-items-center  ">
            <div className="d-flex align-items-center justify-content-center">
              {!loadingWeek && week.key.lastweek && (
                <button
                  style={{
                    border: "none",
                    backgroundColor: "#E42A3F",
                    borderRadius: "10px",
                    color: "#fff",
                    padding: "5px 10px",
                  }}
                  className="text-center m-0  d-flex align-items-center "
                  onClick={() => {
                    getWeek({
                      item_id: item.id,
                      date: !loadingWeek && week.key.lastweek,
                    });
                  }}
                >
                  <>
                    <img
                      src={window.origin + `/WebSide/assets/images/${46}.png`}
                      alt="هفته قبل"
                      style={{
                        width: "20px",
                        height: "20px",
                        marginLeft: "10px",
                      }}
                    />{" "}
                    {" هفته قبل"}
                  </>
                </button>
              )}
            </div>
          </div>
          <div className="col-2 d-none d-sm-block col-lg-8 align-items-center ">
            <div
              className="d-flex align-items-center  "
              style={{
                flexDirection: "column",
              }}
            >
              <p>{/* <span>سال {getYear(days && days[5], week)}</span> */}</p>
              <p onClick={() => {
                getWeek({
                  item_id: item.id,
                });
              }}
                className="text-center"
                style={{
                  color: "#aaa",
                  cursor: "pointer",
                }}
              >
                {/* {!loadingWeek &&
                  checkCurrentWeek(week) &&
                  ` امروز : ${moment().locale("fa").format("YYYY/MM/DD")}`}
                {!loadingWeek && !checkCurrentWeek(week) && "برو به امروز"} */}
              </p>
            </div>
          </div>
          <div className="col-6 col-sm-5 col-lg-2 d-flex  align-items-center justify-content-end ">
            <div className="d-flex align-items-center justify-content-center">
              {!loadingWeek && week.key.nextweek && (
                <button
                  style={{
                    border: "none",
                    backgroundColor: "#E42A3F",
                    borderRadius: "10px",
                    color: "#fff",
                    padding: "5px 10px",
                  }}
                  className="d-flex align-items-center justify-content-between text-center"
                  onClick={() => {
                    getWeek({
                      item_id: item.id,
                      date: !loadingWeek && week.key.nextweek,
                    });
                  }}
                >
                  <>
                    {" هفته بعد"}
                    <img
                      src={window.origin + `/WebSide/assets/images/${47}.png`}
                      alt="هفته قبل"
                      style={{
                        width: "20px",
                        height: "20px",
                        marginRight: "10px",
                      }}
                    />{" "}
                  </>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      {loadingWeek ? (
        <Loading count={1} col={12} height={250} />
      ) : (
        <div
          className="w-100"
          style={{ whiteSpace: "nowrap", overflowX: "auto" }}
        >

          <table
            className="table table-responsive "
            style={{
              border: "1px solid #eee",
              borderRadius: "5px",
            }}
          >
            <thead style={{}}>
              <tr>
                <th scope="col" style={{ border: "none" }}></th>
                {!loadingWeek &&
                  days.map((day, key) => (
                    <th
                      key={key}
                      style={{
                        backgroundColor: "#fff",
                        borderStyle: "dashed",
                        borderBottomColor: "#eee",
                        fontWeight: "400",
                      }}
                      className={"day-sans-table " + (isApp && "p-2")}
                    >
                      <div className="d-flex flex-column day-table">
                        <span
                          style={{
                            color: "#444",
                            fontWeight: "400",
                          }}
                          className="text-center"
                        >
                          {convertDay(day)}
                        </span>
                        <span
                          style={{
                            color: "#999",
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                          className="text-center"
                        >
                          {getDate(day, week)}
                        </span>
                      </div>
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {!loadingWeek &&
                week.template.map((temp, count) => (
                  <tr key={count}>
                    <td
                      style={{
                        border: "none",
                        padding: "0px",
                        borderStyle: "dashed",
                        borderColor: "#eee",
                        borderWidth: 1,
                        textAlign: "center",
                        verticalAlign: "middle",
                        color: "#444",
                        backgroundColor: "#fff",
                        fontWeight: "400",
                      }}
                      scope="row"
                      className="text-center time-sans-table"
                    >
                      {window.screen.width > 700
                        ? `${temp.time.split("-")[0]} تا ${temp.time.split("-")[1]
                        }`
                        : temp.time.split("-")[0]}
                    </td>
                    {days.map((day, key) => (
                      <Sans
                        key={key}
                        loading={loadingSans}
                        data={week.times[day].times[count]}
                        day={getDate(day, week, true)}
                        item={item}
                        set={changeStatus}
                        options={week.option}
                        setShowModalLogin={setShowModalLogin}
                        isApp={isApp}
                      />
                    ))}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export const Sans = ({ data, item, day, set, loading, options, setShowModalLogin, isApp }) => {
  const { statusHandler } = useTableWeek();
  const navigate = useNavigate();
  const { user } = useSelector(state => state);
  return (
    <td
      onClick={() => {
        if (user) {
          statusHandler(data, day)["status"] &&
            set({
              time: data,
              item,
              expiryTime: addTime(100),
              count: 1,
              childcount: 0,
              timeOption: options,
              reqball: false
            });
        } else {
          toast.error("کاربر محترم لطفا ابتدا ثبت نام کنید");
          setTimeout(() => {
            setShowModalLogin(true)
          }, 1000);
        }
      }}
      className={`text-center sans-table position-relative tdApp ${statusHandler(data, day)["status"] &&
        "sans-table-hover position-relative tdApp"
        }`}
      style={statusHandler(data, day) && statusHandler(data, day)["style"]}
    >
      {statusHandler(data, day).status && (data.second_price
        ? (
          <span
            style={{
              position: "absolute",
              color: Color.primary,
              fontSize: window.innerWidth > 764 ? "14px" : "8px",
              left: 0,
              top: 0,
            }}>
            {isApp
              ? "%"
              : "تخفیف"
            }

          </span>
        )
        : (+data.boxofficeprice > +data.price &&
          <span
            style={{
              position: "absolute",
              color: Color.primary,
              fontSize: window.innerWidth > 764 ? "14px" : "8px",
              left: 0,
              top: 0,
            }}>
            {isApp
              ? "%"
              : "تخفیف"
            }
          </span>
        )
      )}

      <span className="text-center">
        {loading.id == data.id && loading.day == data.day_id ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        ) : (
          <CellRender
            time={data}
            data={statusHandler(data, day)}
            options={options}
          />
        )}
      </span>
    </td>
  );
};

const CellRender = ({ data, time, options }) => {
  let elements = [
    { key: "needtitle", ele: "title" },
    { key: "needgender", ele: "gender" },
  ];
  console.log(data);

  if (data.empty) {
    return data.text;
  } else if (data.pass) {
    return data.text;
  } else {
    return (
      <div className="d-flex flex-column">
        {elements.map(ele => {
          if (options[ele.key]) {
            if (ele.ele == "gender") {
              return <div> {GenderRender(time[ele.ele])}</div>;
            }
            return <div>
              {time[ele.ele]}</div>;
          }
        })}

        <div>{RenderPrice(time)}</div>
      </div>
    );
  }
};
